var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonTab',{attrs:{"tabTitle":"Products"}},[_c('div',[_vm._v("This is content for Products Tab")])])}
var staticRenderFns = []

export { render, staticRenderFns }